import { Box, Button, Card, CardContent } from "@mui/material";
import React, { useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import AlertComponent from "../../../../Components/AlertComponent";
import LoanProfileTabs from "./LoanProfileTabs";
import ErrorDisplay from "../../../../Components/ErrorDisplay";
import Page from "../../../../Components/Page";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FetchHook from "../../../../Api/FetchHooks";

const UserLoanProfile = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { state } = location;

  const [user, setUser] = useState(state.user);
  const [data, setLoanData] = useState(state.loan);

  const [dialog, setDialog] = useState({
    open: false,
    type: null,
    label: null,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const [userLoading, userResponse, userRequest] = FetchHook();

  const fetchData = useCallback(async () => {
    if (!user) {
      await userRequest({
        url: `/entity?type=customer&entity_id=${data.entity_id}`,
      });
    }
  }, [data]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (
      userResponse &&
      userResponse.status === 200 &&
      userResponse.data.StatusCode === 0
    )
      setUser(userResponse.data.Data[0]);
  }, [userResponse]);

  // const [loading, response, request] = PostHooks();

  // useEffect(() => {
  //   if (response && response.data.StatusCode === 0) {
  //     setSnackbar({
  //       open: true,
  //       severity: "success",
  //       message: "Request successful!",
  //     });
  //   } else if (response && response.data.StatusCode !== 0) {
  //     setSnackbar({
  //       open: true,
  //       severity: "error",
  //       message: response.data.StatusMessage,
  //     });
  //   } else if (response && response.status !== 200) {
  //     setSnackbar({
  //       open: true,
  //       severity: "error",
  //       message: response.data.StatusMessage,
  //     });
  //   }
  // }, [response]);

  if (!data) {
    return (
      <Box sx={{ p: { xs: 2, md: 4 } }}>
        <ErrorDisplay
          message="No Loan Data Found"
          details="Please go back to the loans list and select a loan to view its profile."
          actions={
            <Button variant="contained" onClick={() => navigate(-1)}>
              Go Back
            </Button>
          }
        />
      </Box>
    );
  }

  return (
    <Page
      title={"Loan Profile"}
      actions={
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
      }
    >
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleCloseSnackbar}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <Card elevation={5}>
        {/* < > */}
        <LoanProfileTabs data={data} user={user} />
        {/* </  > */}
      </Card>
    </Page>
  );
};

export default UserLoanProfile;
